import React, { useEffect, useRef, useState } from "react";
import AppStandardButton from "../../components/UI/AppButtons";
import BookingGetters from "../../store/onlineBooking/getters";
import { ReservationDetailsPreview } from "../../components/Layouts/ReservationDetailsPreview/ReservationDetailsPreview";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  AllPaymentMethodsResponse,
  PaymentBody,
} from "../../@types/DTO/AllPaymentMethods";
import { PayPal } from "../../components/Layouts/PaymentForms/PayPal";
import { createSearchParams, useNavigate } from "react-router-dom";
import BookingApi from "../../API/Apis/BookingApi";
import { Vehicle } from "../../@types/DTO/Vehicles";
import { SelectedVehicleDetails } from "../../@types/Booking/SelectedVehicleDetails";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import PersonalDetails from "./PersonalDetails";
import NewPersonalDetails from "./NewPersonalDetails";
import CompanyDetails from "./CompanyDetails";
import NewCompanyDetails from "./NewCompanyDetails";
import TermsAndConditions from "./TermsAndConditions";
import AlertMessage from "../AlertMessage";
import i18n, { t } from "i18next";
import { AppRadioButton } from "../../components/UI/AppRadioButtons/AppRadioButtons";
import AppButton from "../../components/UI/AppButtons";
import { PrivacyPolicy } from "../../@types/DTO/privacyPolicy";
import { BOOKING_ACTIONS } from "../../store/onlineBooking";
import { useDispatch } from "react-redux";

function PaymentDetailsPage({
  reservationSourcePayNow,
  reservationSourcePayLater,
  updateVehiclePrice,
  updateSelectedPrice,
  allPayNowMethods,
  allPayLaterMethods,
  updateActiveStep,
  isAirport,
  showScalapayWidgetPayLater,
  showScalapayWidgetPayNow,
  scalapayMerchantToken,
  scalapayEnvVal,
  localeScalapay,
  paymentType,
  onPaymentTypeChange,
  updateVehiclePriceLater,
}) {
  const isEnableNewPayPalConfiguration =
    (Array.isArray(allPayNowMethods?.paypal) &&
      allPayNowMethods.paypal[0]?.enableNewPayPalConfiguration) ||
    (Array.isArray(allPayLaterMethods?.paypal) &&
      allPayLaterMethods.paypal[0]?.enableNewPayPalConfiguration);

  const { t: translate } = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [searchParams] = useSearchParams();
  const scriptChannel = searchParams.get("scriptChannel") ?? "";
  const resSourcePayLater =
    searchParams.get("reservationSourcePayLater") === "true";
  const [typePayment, setTypePayment] = useState<"payNow" | "payLater">(
    resSourcePayLater ? "payLater" : "payNow"
  );

  const [showBillingDetails, setShowBillingDetails] = useState<boolean>(false);
  const [handleBillingHeight, setHandleBillingHeight] =
    useState<boolean>(false);

  const [paymentTypeCompanyDetails, setPaymentTypeCompanyDetails] =
    useState(typePayment);
  useEffect(() => {
    const type = !scriptChannel
      ? resSourcePayLater
        ? "payLater"
        : typePayment
      : typePayment;
    setPaymentTypeCompanyDetails(type);
  }, [typePayment]);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [invalidError, setInvalidError] = useState("");
  const [dateError, setDateError] = useState("");
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const updateUserPrimaryDetails = (key, value) => {
    if (key == "firstName") {
      setFirstName(value);
    } else if (key == "lastName") {
      setLastName(value);
    } else if (key == "email") {
      setEmail(value);
    } else if (key == "telephone") {
      setPhoneNo(value);
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (firstName && lastName && email) {
      dispatch(
        BOOKING_ACTIONS.setCustomerPrimaryDetails({
          firstName,
          lastName,
          email,
          telephone: phoneNo,
        })
      );
    }
  }, [firstName, lastName, email, phoneNo]);
  const [companyinvoiceDetails, setCompanyinvoiceDetails] = useState<any>([]);
  const currentLoggedInuser: string | undefined =
    localStorage.getItem("userID") || undefined;
  const navigateTo = useNavigate();
  const lang = i18n.language;
  const payPalFormRef = useRef<HTMLFormElement>();
  const AppSettings = BookingGetters.getAppSettings();
  const [checked, setChecked] = React.useState(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  const ReservationDetails = BookingGetters.getBookingDetails();
  const [ReservationId, setReservationId] = useState<number>(0);
  const VehicleDetails = BookingGetters.getSelectedVehicleDetails();
  const [extrasSelected, setExtrasSelected] = useState<SelectedVehicleDetails>(
    []
  );
  const [userId] = useState(localStorage.getItem("userID"));
  useEffect(() => {
    setExtrasSelected(VehicleDetails.paymentDetails);
  }, []);
  const UserDetails = BookingGetters.getUserDetails();
  const [whetherIfGroupIsOnRequest, setWhetherIfGroupIsOnRequest] =
    useState<string>("false");
  useEffect(() => {
    if (VehicleDetails.vehicleDetails?.Status.toLowerCase() == "onrequest") {
      setWhetherIfGroupIsOnRequest("true");
    } else setWhetherIfGroupIsOnRequest("false");
  });
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const [paypalBody, setPaypalBody] = useState<string | undefined>();
  const [stripeBody, setStripeBody] = useState<string | undefined>();
  const [nexiBody, setNexiBody] = useState<string | undefined>();
  const [scalapayBody, setScalapayBody] = useState<string | undefined>();
  const [customerBlacklistMessageBody, setcustomerBlacklistMessageBody] =
    useState<string | undefined>();
  const [bookingPaymentSubDescData, setBookingPaymentSubDescData] = useState<
    string | undefined
  >();
  const [invalidTaxCodeBody, setInvalidTaxCodeBody] = useState<
    string | undefined
  >();
  const id: any = localStorage.getItem("userID");
  useEffect(() => {
    const fetchTextResources = async () => {
      const [
        PayPalPayLabelObject,
        stripePayLabelObject,
        nexiPayLabelObject,
        scalapayLabelObject,
        customerBlacklistMessageObject,
        invalidTaxCodeObject,
      ] = [
        "PayPalPayLabel",
        "stripePayLabel",
        "nexiPayLabel",
        "scalapayPayLabel",
        "customer_blacklist_message",
        "invalidTaxCodeMessage",
      ].map((key) => data.find((item) => item?.key === key));

      setPaypalBody(PayPalPayLabelObject?.body);
      setStripeBody(stripePayLabelObject?.body);
      setNexiBody(nexiPayLabelObject?.body);
      setScalapayBody(scalapayLabelObject?.body);
      setcustomerBlacklistMessageBody(customerBlacklistMessageObject?.body);
      setBookingPaymentSubDescData(
        data.find((item) => item.key === "PaymentSubDescLabel")?.body
      );
      setInvalidTaxCodeBody(invalidTaxCodeObject?.body);
    };
    fetchTextResources();
  }, [lang, textResource, translate]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<string>("");
  // ****************************** mode of payment logic **********************************
  const [allNewPaymentMethods, setAllNewPaymentMethods] = useState<
    Partial<AllPaymentMethodsResponse>
  >({});
  const showCreditCardDeferredPayment =
    AppSettings?.showCreditCardDeferredPayment;
  const [enableCreditCardDeferredPayment, setEnableCreditCardDeferredPayment] =
    useState(false);

  const getPreferredMethod = (
    methods: Record<string, any>,
    mode: "payLater" | "payNow"
  ) => {
    const keys = Object.keys(methods || {});
    if (keys.length === 0) return null;

    if (keys.length === 1) return keys[0];

    if (mode === "payLater") {
      const wire = keys.find((k) => k.toLowerCase() === "wiretransfer");
      if (wire) return wire;

      const nexi = keys.find((k) => k.toLowerCase() === "nexi");
      if (nexi) return nexi;
    }

    if (mode === "payNow") {
      const nexi = keys.find((k) => k.toLowerCase() === "nexi");
      if (nexi) return nexi;
    }

    return keys[0];
  };

  useEffect(() => {
    const isPayLater =
      (typePayment === "payLater" &&
        VehicleDetails.paymentDetails?.type?.toUpperCase() === "PAYLATER") ||
      reservationSourcePayLater === "true";

    const isPayNow =
      typePayment === "payNow" &&
      VehicleDetails.paymentDetails?.type?.toUpperCase() === "PAYNOW";

    const methodsBasedOnSelection = isPayLater
      ? allPayLaterMethods
      : allPayNowMethods;

    setAllNewPaymentMethods(methodsBasedOnSelection);

    const preferredMethod = getPreferredMethod(
      methodsBasedOnSelection,
      isPayLater ? "payLater" : "payNow"
    );

    if (preferredMethod) {
      setSelectedPaymentMethod(preferredMethod.toUpperCase());
    }

    if (
      showCreditCardDeferredPayment &&
      methodsBasedOnSelection?.creditCardDeferred
    ) {
      setSelectedPaymentMethod("WIRETRANSFER");
      setEnableCreditCardDeferredPayment(true);
    } else {
      setEnableCreditCardDeferredPayment(false);
    }

    if (currentLoggedInuser) {
      const methodsForLoggedInUser = methodsBasedOnSelection;
      const methodKeys = Object.keys(methodsForLoggedInUser || {});

      if (isPayLater) {
        const wire = methodKeys.find((k) => k.toLowerCase() === "wiretransfer");
        if (wire) {
          setSelectedPaymentMethod(wire);
          return;
        }

        const nexi = methodKeys.find((k) => k.toLowerCase() === "nexi");
        if (nexi) {
          setSelectedPaymentMethod(nexi);
          return;
        }

        setSelectedPaymentMethod(methodKeys[0]);
        return;
      }

      if (isPayNow) {
        const nexi = methodKeys.find((k) => k.toLowerCase() === "nexi");
        if (nexi) {
          setSelectedPaymentMethod(nexi);
          return;
        }

        setSelectedPaymentMethod(methodKeys[0]);
        return;
      }
    }
  }, [
    typePayment,
    allPayLaterMethods,
    allPayNowMethods,
    reservationSourcePayLater,
    showCreditCardDeferredPayment,
    currentLoggedInuser,
    VehicleDetails.paymentDetails?.type,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!VehicleDetails?.paymentDetails?.price) {
        navigateTo("/");
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  createSearchParams({
    dropOffDateAndTime: new Date(ReservationDetails.dropOffDateAndTime)
      .getTime()
      .toString(),
    pickUpDateAndTime: new Date(ReservationDetails.pickUpDateAndTime)
      .getTime()
      .toString(),
    pickUpLocation: ReservationDetails.pickUpLocationDetails.code,
    dropOffLocation: ReservationDetails.dropOffLocationDetails.code,
    reservationSource: ReservationDetails.reservationSource.code,
    macroGroupName: ReservationDetails.macroGroupName,
    discountValueWithoutVat: ReservationDetails.discountValueWithoutVat,
    agreementCoupon: ReservationDetails.agreementCoupon,
    showPics: "true",
    showOptionalImage: "true",
    showVehicleParameter: "true",
    showVehicleExtraImage: "true",
    showBookingDiscount: "true",
    isYoungDriverAge: ReservationDetails.isYoungDriverAge,
    isYoungDriver2Age: ReservationDetails.isYoungDriver2Age,
    isSeniorDriverAge: ReservationDetails.isSeniorDriverAge,
    noFeeAge: ReservationDetails.noFeeAge,
  }).toString();

  // ******************************   new features added for rentalplus **********************************
  const [userType, setUserType] = useState("Private");
  const handleUserType = (userType: string) => {
    setUserType(userType);
  };
  useEffect(() => {
    requestParentResize(checked, handleBillingHeight);
  }, [checked, userType, handleBillingHeight]);
  const extraPaymentIFrameMobile =
    Number(AppSettings?.iframeHeightPaymentPageForMobile) || 0;
  const extraPaymentIFrameDesktop =
    Number(AppSettings?.iframeHeightForPaymentPage) || 0;
  //below code is for iframe mainly for mobile view
  const paymentFormRef = useRef<HTMLDivElement>(null);

  // const recapHeight = isExpanded1
  //   ? 377
  //   : isExpanded2
  //   ? 361
  //   : isExpanded3
  //   ? 371
  //   : isExpanded4
  //   ? 349
  //   : 221;

  function requestParentResize(
    checked: boolean,
    billingVisible: boolean = handleBillingHeight
  ) {
    let iframeHeight;

    const isCompany = userType === "Company";
    const isPrivate = userType === "Private";
    const isIndividual = userType === "Individual";

    const isEmptyUserType =
      !userType || (typeof userType === "string" && userType.trim() === "");
    const showPayNow =
      reservationSourcePayNow === "true" && showScalapayWidgetPayNow;

    const showPayLater =
      reservationSourcePayLater === "true" && showScalapayWidgetPayLater;
    const hideFields =
      AppSettings?.hideNumberOfFieldsAtPayNow ||
      AppSettings?.hideNumberOfFieldsAtPayAtDesk;

    if (checked) {
      iframeHeight = isCompany
        ? isSmallScreen
          ? 4517
          : 2260
        : isSmallScreen
        ? 5189
        : 2508;
    } else {
      if (isCompany) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 3600 : 2000;
        } else if (hideFields && !billingVisible) {
          iframeHeight = isSmallScreen ? 4000 : 2250;
        } else {
          iframeHeight = isSmallScreen ? 3920 : 2200;
        }
      } else if (isPrivate) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 3700 : 2100;
        } else if (hideFields && !billingVisible) {
          iframeHeight = isSmallScreen ? 4090 : 2350;
        } else {
          iframeHeight = isSmallScreen ? 4020 : 2300;
        }
      } else if (isIndividual) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 4300 : 2300;
        } else {
          iframeHeight =
            hideFields && !billingVisible
              ? isSmallScreen
                ? 4680
                : 2540
              : isSmallScreen
              ? 4600
              : 2490;
        }
      } else {
        // EMPTY USER TYPE
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 2080 : 1380;
        } else if (showPayNow || showPayLater) {
          iframeHeight = isSmallScreen ? 2080 : 1380;
        } else if (hideFields && billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 2400 : 1500;
        } else if (!billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 2850 : 1830;
        } else if (billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 4280 : 1700;
        } else {
          iframeHeight = isSmallScreen ? 4280 : 2400;
        }
      }
    }

    // EXTRA HEIGHT
    if (isEmptyUserType && billingVisible) {
      iframeHeight += isSmallScreen ? 250 : 200;
    }

    iframeHeight += isSmallScreen
      ? extraPaymentIFrameMobile
      : extraPaymentIFrameDesktop;

    const extraheightforDesktop = showPayNow || showPayLater ? 180 : 0;
    const extraheightforMobile = showPayNow || showPayLater ? 370 : 70;

    iframeHeight += isSmallScreen
      ? extraPaymentIFrameMobile + extraheightforMobile
      : extraPaymentIFrameDesktop + extraheightforDesktop;
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: { iframeHeight },
      },
      "*"
    );
  }

  const appSettings = BookingGetters.getAppSettings();
  const fontFamilyStyle = appSettings?.fontFamily;

  const [selectedPrivacyPolicy, setSelectedPrivacyPolicy] = useState<string[]>(
    []
  );
  const [requiredPolicy, setRequiredPrivacyPolicy] = useState<string[]>([]);
  const [allPrivacyPolicy, setAllPrivacyPolicy] = useState<
    PrivacyPolicy["privacyPolicy"]
  >([]);
  useEffect(() => {
    if (AppSettings?.showMyRentPolicies) {
      BookingApi.getPrivacyPolicy(null, "booking").then((response) => {
        const fetchedPolicies = response.data.privacyPolicy.map((item) => {
          const policyGroup = item.policyGroup;
          return policyGroup;
        });
        setAllPrivacyPolicy(fetchedPolicies);

        const getPolicies = (condition) =>
          fetchedPolicies.flatMap((policyArray) =>
            policyArray
              .filter(condition)
              .map((policy) =>
                i18n.language === "it"
                  ? policy.privacyPolicyLocalLang
                  : policy.privacyPolicyEn
              )
          );
        setSelectedPrivacyPolicy(
          getPolicies((policy) => policy.isDefaultAccepted)
        );
        setRequiredPrivacyPolicy(getPolicies((policy) => policy.isMandatory));
        setRequiredPrivacyPolicy(requiredPolicy);
      });
    }
  }, []);
  const countryList = AppSettings?.config.country;

  const updateSelectedPrivacyPolicy = (index, value) => {
    setSelectedPrivacyPolicy((prev) => {
      prev[index] = value;
      return [...prev];
    });
  };
  const [currentPriceToPay, setCurrentPriceToPay] = useState(0);
  const [percentageAmtOfExtras] = useState(
    AppSettings?.percentageAmountForExtras
  );
  const [percentOnAmount] = useState(AppSettings?.percentOnAmount);
  const [percentOnPayLaterAmount] = useState(
    AppSettings?.percentOnPayLaterAmount
  );
  const payType = VehicleDetails.paymentDetails?.type;

  useEffect(() => {
    const price = VehicleDetails?.paymentDetails?.price;
    if (percentOnAmount != null && (payType == "PAYNOW" || payType == "")) {
      let totalPrice = price;

      if (!VehicleDetails?.paymentDetails?.extrasIncluded) {
        totalPrice += extrasSelected?.extrasPrice;
      }

      const updatedPrice =
        (totalPrice ? totalPrice * percentOnAmount : 0) / 100;

      setCurrentPriceToPay(updatedPrice);
    } else if (percentOnPayLaterAmount != null && payType == "PAYLATER") {
      let totalPrice = price;

      if (!VehicleDetails?.paymentDetails?.extrasIncluded) {
        totalPrice += extrasSelected?.extrasPrice;
      }

      /* ----------- SURCHARGE LOGIC ADDED ----------- */
      let surchargeAmount = 0;

      const surchargePercent =
        VehicleDetails?.vehicleDetails?.Vehicle?.payLaterSurcharge ?? undefined;
      if (surchargePercent !== undefined) {
        surchargeAmount = (totalPrice * surchargePercent) / 100;
        totalPrice += surchargeAmount;
      }
      /* ----------- END SURCHARGE LOGIC ----------- */

      const updatedPrice =
        (totalPrice ? totalPrice * percentOnPayLaterAmount : 0) / 100;
      setCurrentPriceToPay(updatedPrice);
    } else if (percentageAmtOfExtras != null && price != null && price > 0) {
      // logic added to set how much % of extras & insurance amount customer will pay at the time of creating booking
      if (VehicleDetails?.paymentDetails?.extrasIncluded) {
        setCurrentPriceToPay(
          (extrasSelected?.extrasPrice *
            parseFloat(percentageAmtOfExtras.toString())) /
            100 +
            parseFloat(price.toString()) -
            extrasSelected?.extrasPrice
        );
      } else {
        setCurrentPriceToPay(
          (extrasSelected?.extrasPrice *
            parseFloat(percentageAmtOfExtras.toString())) /
            100 +
            parseFloat(price.toString())
        );
      }
    } else if (VehicleDetails?.paymentDetails?.price != null) {
      if (VehicleDetails?.paymentDetails?.extrasIncluded) {
        setCurrentPriceToPay(VehicleDetails?.paymentDetails?.price);
      } else {
        setCurrentPriceToPay(
          VehicleDetails?.paymentDetails?.price + extrasSelected?.extrasPrice
        );
      }
    }
  }, [
    percentageAmtOfExtras,
    VehicleDetails?.paymentDetails,
    extrasSelected,
    payType,
  ]);

  const [loading, setLoading] = useState(false);
  const blurScreen = () => {
    document.body.style.opacity = String(0.5);
    document.body.style.pointerEvents = "none";
  };
  useEffect(() => {
    if (loading) {
      blurScreen();
    } else {
      document.body.style.opacity = String(1);
      document.body.style.pointerEvents = "";
    }
  }, [loading]);

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isCloseButton, setIsCloseButton] = useState(false);

  const onRequestClose = () => {
    setOpenModal(false);
    setModalMessage("");
    if (isCloseButton == true) {
      updateActiveStep();
    }
  };

  const novehicleModal = (msg) => {
    setModalMessage(msg);
    setOpenModal(true);
    setIsCloseButton(true);
  };
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      "*"
    );
  };
  const isSmallScreen = window.innerWidth <= 768;
  const isTabletScreen = window.innerWidth <= 1024;

  const isHidePayCounterRadio = AppSettings?.hidePayAtCounterRadioButton;
  const hideNumberOfFieldsAtPayAtDesk =
    AppSettings?.hideNumberOfFieldsAtPayAtDesk ?? false;

  const isResSoucePayNow =
    searchParams.get("reservationSourcePayNow") === "true";
  const restrictBlacklistCustomersFromBooking =
    AppSettings?.restrictBlacklistCustomersFromBooking;
  useEffect(() => {
    if (
      (paymentType &&
        paymentType == "payLater" &&
        scriptChannel &&
        hideNumberOfFieldsAtPayAtDesk) ||
      (!scriptChannel &&
        reservationSourcePayLater == "true" &&
        hideNumberOfFieldsAtPayAtDesk)
    ) {
      setUserType("");
    } else if (paymentType && paymentType == "payNow" && scriptChannel) {
      setUserType("Private");
    } else if (
      hideNumberOfFieldsAtPayAtDesk &&
      AppSettings?.showOnePayMethodTwoPrice &&
      !isResSoucePayNow
    ) {
      setUserType("");
    }
  }, [paymentType]);

  // const typeOfUser = userType === "Company" ? "Company" : "INDIVIDUAL";
  // const userData = {
  //   ...UserDetails,
  //   customerType: typeOfUser.toUpperCase(),
  // };
  const showByPaymentType =
    paymentType === "payNow"
      ? showScalapayWidgetPayNow === true
      : paymentType === "payLater"
      ? showScalapayWidgetPayLater === true
      : false;

  const showForScriptChannel =
    (scriptChannel &&
      ((paymentType == "payNow" && showScalapayWidgetPayNow) ||
        (paymentType == "payLater" && showScalapayWidgetPayLater))) ||
    (!scriptChannel &&
      ((reservationSourcePayNow == "true" && showScalapayWidgetPayNow) ||
        (reservationSourcePayLater == "true" && showScalapayWidgetPayLater)));

  const showForNonScriptChannel =
    scriptChannel == "" &&
    reservationSourcePayNow === "false" &&
    reservationSourcePayLater === "false" &&
    (showScalapayWidgetPayNow === true || showScalapayWidgetPayLater === true);

  const shouldShowScalapayWidget =
    showByPaymentType && (showForScriptChannel || showForNonScriptChannel);

  return (
    <section
      className="flex flex-col "
      style={
        isSmallScreen
          ? { width: "99%", overflow: "hidden" }
          : { width: "100%", overflow: "hidden" }
      }
    >
      <AlertMessage
        openModal={openModal}
        requestOnClose={onRequestClose}
        modalMessage={modalMessage}
      />
      <div
        className={`flex justify-center items-center ${
          isSmallScreen ? "mt-[10%]" : ""
        }`}
      ></div>
      <div
        className="grow flex flex-col grow gap-16 box-border p-6 bg-gray-100"
        ref={paymentFormRef}
      >
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (!AppSettings?.showOldPaymentForm && !isValidEmail(email)) {
              setEmailError("Invalid email format");
              emailRef.current ? emailRef.current.focus() : "";
            }
            if (
              (phoneNo == "" || phoneNo.length == 2) &&
              AppSettings?.markPhoneNoRequiredForPrivate
            ) {
              setPhoneError("Phone No is required");
              setInvalidError("Phone No is required");
              // phoneRef.current ? phoneRef.current.focus() : "";
            } else if (
              UserDetails.dateOfBirth == "" &&
              userType == "Private" &&
              !hideNumberOfFieldsAtPayAtDesk
            ) {
              setDateError("This is a required field");
              setInvalidError("DOB is required field");
            } else {
              // first check blacklist API before proceeding
              const blacklistId =
                UserDetails?.ssnNumber || UserDetails?.vatNumber;

              if (blacklistId && restrictBlacklistCustomersFromBooking) {
                const blacklistResponse =
                  await BookingApi.checkIfCustomerIsBlacklisted(
                    String(blacklistId)
                  );

                if (blacklistResponse?.data?.status === "success") {
                  const message =
                    customerBlacklistMessageBody ||
                    t("Cannot continue because your profile is blacklisted.");
                  setModalMessage(message);
                  setOpenModal(true);
                  return;
                }
              }
              setEmailError("");
              setPhoneError("");
              setInvalidError("");
              setIsSaving(true);
              setLoading(true);
              BookingApi.createBooking(
                firstName,
                lastName,
                email,
                phoneNo,
                ReservationDetails,
                UserDetails,
                VehicleDetails.vehicleDetails as Vehicle,
                VehicleDetails.paymentDetails as SelectedVehicleDetails,
                selectedPaymentMethod,
                companyinvoiceDetails,
                currentLoggedInuser,
                whetherIfGroupIsOnRequest,
                userType,
                checked,
                AppSettings?.payWiretransfer,
                AppSettings?.payVpos,
                extrasSelected?.selectedInsurance?.insuranceId,
                extrasSelected?.addedExtraOptions,
                extrasSelected?.extrasPrice,
                countryList || [],
                paymentTypeCompanyDetails,
                hideNumberOfFieldsAtPayAtDesk,
                enableCreditCardDeferredPayment
              ).then((e) => {
                const customer = e.data?.data?.Customer;
                const reservationBookingDetails: PaymentBody = {
                  GivenName: customer?.GivenName || "",
                  Name: customer?.Name || "",
                  Surname: customer?.Surname || "",
                  addressNumber: customer?.addressNumber || "",
                  phNum1: customer?.phNum1 || "",
                  zip: customer?.zip || "",
                  street: customer?.street || "",
                  num: customer?.num || "",
                  email: customer?.email || "",
                  city: customer?.city || "",
                  state: customer?.state || "",
                };
                if (e.toString() === "invalid.customer.ssn") {
                  setIsSaving(false);
                  setLoading(false);
                  const message = invalidTaxCodeBody || t("Invalid Tax Code");
                  setModalMessage(message);
                  // setModalMessage("Invalid Tax Code");
                  setOpenModal(true);
                } else if (e.toString() === "invalid.companyTaxCode") {
                  setIsSaving(false);
                  setLoading(false);
                  setModalMessage("Invalid Company Tax Code");
                  setOpenModal(true);
                } else if (e.toString() === "invalid.company.vat") {
                  setIsSaving(false);
                  setLoading(false);
                  setModalMessage("Invalid VAT");
                  setOpenModal(true);
                } else {
                  if (AppSettings?.showMyRentPolicies) {
                    const policyIds = selectedPrivacyPolicy.map(
                      (selectedPolicy) => {
                        const selectedPolicyIds: number[] = [];
                        let foundPolicy: number | undefined;
                        if (Array.isArray(selectedPolicy)) {
                          for (const p1 of selectedPolicy) {
                            let policyFound = false;
                            for (const p2 of allPrivacyPolicy) {
                              const foundPolicy = p2.find((policy) => {
                                const policyData = p1.startsWith("*")
                                  ? p1.substring(1)
                                  : p1;
                                return (
                                  policyData ===
                                  (i18n.language == "it"
                                    ? policy.privacyPolicyLocalLang
                                    : policy.privacyPolicyEn)
                                );
                              });
                              if (foundPolicy) {
                                selectedPolicyIds.push(foundPolicy.id);
                                policyFound = true;
                                break;
                              }
                            }
                            if (!policyFound) {
                              selectedPolicyIds.push(-1);
                            }
                          }
                        }
                        return selectedPolicyIds;
                      }
                    );
                    BookingApi.savePrivacyPolicy(
                      e?.data?.data?.dbId,
                      policyIds.flat()
                    ); // Flatten nested arrays before saving for single array
                  }

                  setReservationId(e?.data.data?.dbId);
                  setIsSaving(false);
                  setLoading(false);
                  if (e.data.data == undefined) {
                    novehicleModal(e.data.message);
                  } else {
                    switch (selectedPaymentMethod.toLowerCase()) {
                      case "paypal": {
                        if (!isEnableNewPayPalConfiguration) {
                          payPalFormRef?.current?.submit();
                        } else {
                          if (
                            AppSettings?.onrequestPayAmount &&
                            VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                              "onrequest"
                          ) {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              0.01,
                              "paypal",
                              reservationBookingDetails
                            ).then((e) => {
                              if (e.paymentUrl && e.status != "failed") {
                                window.open(e.paymentUrl, "_self");
                                window.scrollTo(0, 0);
                                scrollToTop();
                              } else {
                                navigateTo("/MovementRenewal/UrlNotDonePayPal");
                              }
                            });
                          } else {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              currentPriceToPay || 0,
                              "paypal",
                              reservationBookingDetails
                            ).then((e) => {
                              if (e.paymentUrl && e.status != "failed") {
                                window.scrollTo(0, 0);
                                scrollToTop();
                                window.open(e.paymentUrl, "_self");
                              } else {
                                navigateTo("/MovementRenewal/UrlNotDonePayPal");
                              }
                            });
                          }
                        }
                        break;
                      }
                      case "nexi": {
                        const handleNexiPayment = (link: string) => {
                          window.scrollTo(0, 0);
                          scrollToTop();
                          window.open(link, "_self");
                          window.scrollTo(0, 0);
                          scrollToTop();
                        };

                        const processNexiResponse = (e: {
                          bookingPaymentLink?: string;
                          generateLink?: string;
                        }) => {
                          console.log(
                            e.bookingPaymentLink,
                            "e.bookingPaymentLink"
                          );
                          console.log(e.generateLink, "e.generateLink");
                          const paymentLink =
                            e.bookingPaymentLink || e.generateLink;
                          if (paymentLink) {
                            handleNexiPayment(paymentLink);
                          }
                        };

                        if (
                          AppSettings?.onrequestPayAmount &&
                          VehicleDetails.vehicleDetails?.Status.toLowerCase() ===
                            "onrequest"
                        ) {
                          BookingApi.getPaymentLink(
                            e.data.data.dbId,
                            0.01,
                            "nexi",
                            reservationBookingDetails
                          ).then(processNexiResponse);
                        } else {
                          BookingApi.getPaymentLink(
                            e.data.data.dbId,
                            currentPriceToPay || 0,
                            "nexi",
                            reservationBookingDetails
                          ).then(processNexiResponse);
                        }
                        break;
                      }
                      case "scalapay": {
                        if (
                          AppSettings?.onrequestPayAmount &&
                          VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                            "onrequest"
                        ) {
                          BookingApi.getPaymentLink(
                            e.data.data.dbId,
                            0.01,
                            "scalapay",
                            reservationBookingDetails
                          ).then((e) => {
                            if (e.paymentUrl && e.status != "failed") {
                              window.scrollTo(0, 0);
                              scrollToTop();
                              window.open(e.paymentUrl, "_self");
                            } else {
                              navigateTo("/MovementRenewal/UrlNotDoneScalapay");
                            }
                          });
                        } else {
                          BookingApi.getPaymentLink(
                            e.data.data.dbId,
                            currentPriceToPay || 0,
                            "scalapay",
                            reservationBookingDetails
                          ).then((e) => {
                            console.log(e, "scalapay payment link");
                            if (e.paymentUrl && e.status != "failed") {
                              window.scrollTo(0, 0);
                              scrollToTop();
                              window.open(e.paymentUrl, "_self");
                            } else {
                              navigateTo("/MovementRenewal/UrlNotDoneScalapay");
                            }
                          });
                        }
                        break;
                      }
                      case "stripe": {
                        BookingApi.getPaymentLink(
                          e.data.data.dbId,
                          currentPriceToPay || 0,
                          "Stripe",
                          reservationBookingDetails
                        ).then((e) => {
                          if (e.paymentUrl) {
                            const paymentData = {
                              ...e,
                              paymentMode: "Stripe",
                            };
                            if (paymentData.paymentUrl && window.top) {
                              window.top.location.href = paymentData.paymentUrl;
                            } else {
                              window.open(paymentData.paymentUrl, "top");
                            }
                          }
                        });
                        break;
                      }
                      case "wiretransfer": {
                        let dbId = e.data.data?.id;
                        dbId = dbId.split(" ").slice(0, 2).join("");
                        const ResId = e.data.data?.dbId;
                        BookingApi.sendEmailForWireTransfer(
                          e.data.data?.dbId,
                          whetherIfGroupIsOnRequest,
                          i18n.language,
                          id || ""
                        );
                        navigateTo(
                          `/booking/confirmed?dbId=${dbId}&ResId=${ResId}&vehicleName=${e.data.data.Vehicle.VehMakeModel.Name}&vehicleCategory=${e.data.data.Vehicle.Code}&DropOffUpDateTime=${e.data.data.ReturnDateTime}&importo=${currentPriceToPay}`
                        );

                        break;
                      }
                      default: {
                        BookingApi.getPaymentLink(
                          e.data.data.dbId,
                          currentPriceToPay || 0,
                          "nexi"
                        ).then((e) => {
                          if (e.generateLink) {
                            window.scrollTo(0, 0);
                            scrollToTop();
                            window.open(e.generateLink, "_self");
                            window.scrollTo(0, 0);
                            scrollToTop();
                          }
                        });
                        return;
                      }
                    }
                  }
                }
              });
            }
          }}
          className="grow flex flex-col grow gap-16 box-border p-4 bg-gray-100 -align-center"
        >
          {AppSettings?.showOldPaymentForm ? (
            AppSettings?.showCompanyDetailsPriorPersonal ? (
              <>
                <CompanyDetails
                  checked={checked}
                  handleChange={handleChange}
                  userType={userType}
                  handleUserType={handleUserType}
                  setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                  companyinvoiceDetails={companyinvoiceDetails}
                />
                <PersonalDetails
                  reservationSourcePayNow={reservationSourcePayNow}
                  reservationSourcePayLater={reservationSourcePayLater}
                  extrasSelected={extrasSelected}
                  updateVehiclePrice={updateVehiclePrice}
                  updateVehiclePriceLater={updateVehiclePriceLater}
                  updateSelectedPrice={updateSelectedPrice}
                />
              </>
            ) : (
              <>
                <PersonalDetails
                  reservationSourcePayNow={reservationSourcePayNow}
                  reservationSourcePayLater={reservationSourcePayLater}
                  extrasSelected={extrasSelected}
                  updateVehiclePrice={updateVehiclePrice}
                  updateSelectedPrice={updateSelectedPrice}
                  updateVehiclePriceLater={updateVehiclePriceLater}
                />
                <CompanyDetails
                  checked={checked}
                  handleChange={handleChange}
                  userType={userType}
                  handleUserType={handleUserType}
                  setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                  companyinvoiceDetails={companyinvoiceDetails}
                />
              </>
            )
          ) : (
            <>
              <NewPersonalDetails
                reservationSourcePayNow={reservationSourcePayNow}
                reservationSourcePayLater={reservationSourcePayLater}
                extrasSelected={extrasSelected}
                updateVehiclePrice={updateVehiclePrice}
                updateSelectedPrice={updateSelectedPrice}
                updateUserPrimaryDetails={updateUserPrimaryDetails}
                firstName={firstName}
                lastName={lastName}
                email={email}
                phoneNo={phoneNo}
                emailError={emailError}
                emailRef={emailRef}
                phoneRef={phoneRef}
                phoneError={phoneError}
                onPaymentTypeChange={onPaymentTypeChange}
                checkPaymentType={setTypePayment}
                updateVehiclePriceLater={updateVehiclePriceLater}
              />
              {/*<NewCompanyDetails*/}
              {/*  isAirport={isAirport}*/}
              {/*  userType={userType}*/}
              {/*  handleUserType={handleUserType}*/}
              {/*  setCompanyinvoiceDetails={setCompanyinvoiceDetails}*/}
              {/*  companyinvoiceDetails={companyinvoiceDetails}*/}
              {/*  phoneRef={phoneRef}*/}
              {/*  phoneError={phoneError}*/}
              {/*  dateError={dateError}*/}
              {/*/>*/}
              {hideNumberOfFieldsAtPayAtDesk === false &&
                (paymentType === "payNow" || paymentType === "payLater") && (
                  <NewCompanyDetails
                    isAirport={isAirport}
                    userType={userType}
                    handleUserType={handleUserType}
                    setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                    companyinvoiceDetails={companyinvoiceDetails}
                    phoneRef={phoneRef}
                    phoneError={phoneError}
                    dateError={dateError}
                    hideNumberOfFieldsAtPayAtDesk={
                      hideNumberOfFieldsAtPayAtDesk
                    }
                    paymentType={paymentTypeCompanyDetails}
                    setHandleBillingHeight={setHandleBillingHeight}
                    reservationSourcePayNow={reservationSourcePayNow}
                    reservationSourcePayLater={reservationSourcePayLater}
                    scriptChannel={scriptChannel}
                  />
                )}

              {hideNumberOfFieldsAtPayAtDesk === true &&
                (paymentType === "payNow" || paymentType === "payLater") && (
                  <NewCompanyDetails
                    isAirport={isAirport}
                    userType={userType}
                    handleUserType={handleUserType}
                    setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                    companyinvoiceDetails={companyinvoiceDetails}
                    phoneRef={phoneRef}
                    phoneError={phoneError}
                    dateError={dateError}
                    hideNumberOfFieldsAtPayAtDesk={
                      hideNumberOfFieldsAtPayAtDesk
                    }
                    paymentType={paymentTypeCompanyDetails}
                    setHandleBillingHeight={setHandleBillingHeight}
                    reservationSourcePayNow={reservationSourcePayNow}
                    reservationSourcePayLater={reservationSourcePayLater}
                    scriptChannel={scriptChannel}
                  />
                )}
            </>
          )}
          <TermsAndConditions
            updateSelectedPrivacyPolicy={updateSelectedPrivacyPolicy}
            selectedPrivacyPolicy={selectedPrivacyPolicy}
            allPrivacyPolicy={allPrivacyPolicy}
            requiredPolicy={requiredPolicy}
          />
          {((currentLoggedInuser &&
            AppSettings?.reservedAreaShowOnlyOnePayment) ||
            isHidePayCounterRadio) &&
          AppSettings?.showConfirmButtonAtMiddle ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p className="text-red-500">{invalidError}</p>
              <AppButton
                loading={isSaving}
                type="submit"
                color="primary"
                className="h-12 w-44 flex justify-center rounded-sm"
                style={{
                  borderRadius: `${AppSettings?.buttonBorderRadius || 0}px`,
                }}
              >
                <span
                  className="flex text-center w-full h-full mt-3 justify-center"
                  style={{ fontFamily: fontFamilyStyle }}
                >
                  {t("Confirm")}
                </span>
              </AppButton>
            </div>
          ) : (
            <footer className="flex flex-row flex-wrap bg-white box-border p-8">
              <div className="flex flex-col grow">
                {(!currentLoggedInuser ||
                  !AppSettings?.reservedAreaShowOnlyOnePayment) &&
                !isHidePayCounterRadio ? (
                  <>
                    <AppRadioButton
                      required={true}
                      color={"primary"}
                      label={
                        <span style={{ fontFamily: fontFamilyStyle }}>
                          {t("Mode of Payment")}
                        </span>
                      }
                      value={selectedPaymentMethod}
                      options={(isSmallScreen || isTabletScreen
                        ? Object.keys(allNewPaymentMethods).reverse()
                        : Object.keys(allNewPaymentMethods)
                      )
                        .map((key) => {
                          switch (key.toUpperCase()) {
                            case "WIRETRANSFER":
                              return {
                                label: t("Pay at desk"),
                                value: "WIRETRANSFER",
                              };
                            case "PAYPAL":
                              return {
                                label: paypalBody ? paypalBody : t("PayPal"),
                                value: "PAYPAL",
                              };
                            case "NEXI":
                              return {
                                label: nexiBody ? nexiBody : t("Credit card"),
                                value: "NEXI",
                              };
                            case "STRIPE":
                              return {
                                label: stripeBody ? stripeBody : t("Stripe"),
                                value: "STRIPE",
                              };
                            case "SCALAPAY":
                              return {
                                label: (
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <span>
                                      {scalapayBody
                                        ? scalapayBody
                                        : translate("Pay with Scalapay")}
                                    </span>
                                    <img
                                      src="/images/Scalapay_Logo_Primary_Black.png"
                                      alt="Scalapay"
                                      style={{
                                        height: "60px",
                                        width: "100px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </span>
                                ),
                                value: "SCALAPAY",
                              };
                            default:
                              return {
                                label: "",
                                value: "",
                              };
                          }
                        })
                        .flat()
                        .filter((option) => option !== null)}
                      onChange={(e) => {
                        setSelectedPaymentMethod(e);
                      }}
                    />
                    {shouldShowScalapayWidget && (
                      <div style={{ paddingTop: "5px" }}>
                        <hr style={{ border: ".3px solid #ccc" }} />
                        <div
                          style={{
                            paddingTop: "4px",
                            fontSize: "12px",
                            color: "#000",
                          }}
                        >
                          <scalapay-widget
                            locale={localeScalapay}
                            channel="travel"
                            type="checkout"
                            amount={currentPriceToPay.toFixed(2)}
                            merchant-token={scalapayMerchantToken}
                            {...(scalapayEnvVal !== ""
                              ? { environment: scalapayEnvVal }
                              : {})}
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
              </div>

              <div className="flex flex-row gap-6 items-center">
                <p className="text-red-500">{invalidError}</p>
                <AppButton
                  loading={isSaving}
                  type="submit"
                  color="primary"
                  className="h-12 w-44 flex justify-center rounded-sm"
                  style={{
                    borderRadius: `${AppSettings?.buttonBorderRadius || 0}px`,
                  }}
                >
                  <span
                    className="flex text-center w-full h-full mt-3 justify-center"
                    style={{ fontFamily: fontFamilyStyle }}
                  >
                    {t("Confirm")}
                  </span>
                </AppButton>
              </div>
              <span
                dangerouslySetInnerHTML={{
                  __html: bookingPaymentSubDescData || "",
                }}
                className={"text-black w-full mt-2"}
              />
              <div className="flex flex-row text-[#707070] mt-4 mb-2">
                {AppSettings?.onrequestPayAmount &&
                VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                  "onrequest"
                  ? t(
                      "The reservation will be subjected to confirmation – during the payment process, you will be asked to pay €0.01 and, once the reservation is confirmed, you will be charged the total amount of the rental on the registered credit card."
                    )
                  : ""}
              </div>
            </footer>
          )}
        </form>
      </div>
      <div className={"text-black hidden"}>
        {allNewPaymentMethods?.paypal &&
          allNewPaymentMethods?.paypal?.length > 0 && (
            <PayPal
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              ref={payPalFormRef}
              postUrl={
                allNewPaymentMethods.paypal[0]?.developmentMode
                  ? allNewPaymentMethods.paypal[0]?.sandboxPaymentURL || ""
                  : allNewPaymentMethods.paypal[0]?.productionPaymentURL || ""
              }
              companyEmail={
                allNewPaymentMethods.paypal[0]?.developmentMode
                  ? allNewPaymentMethods.paypal[0]?.sandboxEmailCompany || ""
                  : allNewPaymentMethods.paypal[0]?.productionEmailCompany || ""
              }
              amount={currentPriceToPay || 0}
              returnLink={
                allNewPaymentMethods.paypal[0]?.developmentMode
                  ? allNewPaymentMethods.paypal[0]?.sandboxReturnURL || ""
                  : allNewPaymentMethods.paypal[0]?.productionReturnURL || ""
              }
              notify_url={
                allNewPaymentMethods.paypal[0]?.developmentMode
                  ? allNewPaymentMethods.paypal[0]?.sandboxNotifyURL || ""
                  : allNewPaymentMethods.paypal[0]?.productionNotifyURL || ""
              }
              cancel_url={
                allNewPaymentMethods.paypal[0]?.developmentMode
                  ? allNewPaymentMethods.paypal[0]?.sandboxCancelURL || ""
                  : allNewPaymentMethods.paypal[0]?.productionCancelURL || ""
              }
              itemName={"NAME HERE"}
              reservationId={ReservationId}
            />
          )}
      </div>
    </section>
  );
}
export { PaymentDetailsPage };
